"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Header = _interopRequireDefault(require("../components/Header"));
var _kansaReportActions = require("../kansaReportActions");
var _KansaTgtJigyo = _interopRequireDefault(require("./components/KansaTgtJigyo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査報告詳細
 */
class KansaReportDetail extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getEntries", () => {
      const {
        callAPI,
        setEntries,
        detailCondition
      } = this.props;
      let condition = JSON.parse(detailCondition);
      callAPI(_APIs.KANSA_REPORT_DETAIL, condition).then(json => {
        if (json.status === _APIs.STATUS.SUCCESS) {
          setEntries(json.data);
        }
      });
    });
    this.getEntries();
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    const {
      clearDetail
    } = this.props;
    clearDetail();
  }
  render() {
    const {
      intl,
      entries,
      info
    } = this.props;
    const {
      kansaTgtNendoNm,
      kansaTaishoJigyoList,
      hakkenjikoBunrui,
      hikansabumon
    } = entries;
    const closeBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      negative: true,
      autoWidth: true,
      onClick: () => {
        window.close();
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CLOSE
    }));
    return info.ready ? /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_REPORT_DETAIL
      }) + _stringUtil.default.encloseCirKakko(kansaTgtNendoNm ? kansaTgtNendoNm : _stringConsts.STRING_CONSTS.EMPTY),
      actions: [closeBtn]
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 9
      }
    }, /*#__PURE__*/_react.default.createElement(_Header.default, {
      itemList: [{
        labelId: _labelConsts.LABEL.KANSA_SHITEKI_HAKKEN_JIKO_BUNRUI,
        value: hakkenjikoBunrui
      }, {
        labelId: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON,
        value: hikansabumon
      }]
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 3
      },
      align: "right"
    }, closeBtn), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, !kansaTaishoJigyoList || kansaTaishoJigyoList.length === 0 ?
    /*#__PURE__*/
    // 表示する情報がない場合
    _react.default.createElement(_Typography.default, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_TARGET_JIGYO_NOT_FOUND_MESSAGE
    })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, kansaTaishoJigyoList.map(item => {
      return item.hakkenjikoList && item.hakkenjikoList.length > 0 ? /*#__PURE__*/_react.default.createElement(_KansaTgtJigyo.default, {
        kansaTgtJigyoNm: item.kansaTgtJigyoNm,
        hakkenjikoList: item.hakkenjikoList
      }) : null;
    })))))) : null;
  }
}
const mapStateToProps = state => {
  return {
    entries: state.kansaReport.detail.entries,
    info: state.kansaReport.detail,
    detailCondition: state.kansaReport.containerInfo.detailCondition
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntries: entries => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_DETAIL](entries)),
    clearDetail: () => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CLEAR_DETAIL]()),
    goMain: previousContent => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_MAIN](previousContent))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KansaReportDetail)));